nsr.controller('AdminVintController', ['$scope', 'Admin', 'VintCollectionService', function ($scope, Admin, VintCollectionService) {
    $scope.slideovers = {
        account: false,
        collection: false,
        buyDialog: false
    };

    if (window.innerWidth < 500) {
        $scope.slideoverWidth = window.innerWidth + 'px';
    } else {
        $scope.slideoverWidth = 500 + 'px';
    }

    $scope.accounts = [];
    $scope.collections = [];

    $scope.loadData = function () {
        Admin.get('vint-manage').then(function (response) {
            settings = response.data.settings;
            $scope.accounts = response.data.accounts;
            $scope.collections = response.data.collections;
        });
    }

    $scope.$watch(function () {
        return VintCollectionService.doRefreshTrigger
    }, function (n) {
        if (n) {
            VintCollectionService.doRefreshTrigger = false
            $scope.loadData();
        }
    })

    $scope.loadData();
}])

nsr.controller('AdminVintCollectionController', [
    '$scope', 'VintCollectionService', 'TransitionService',
    function ($scope, VintCollectionService, TransitionService) {
        $scope.collection = {}

        $scope.newCollection = function () {
            VintCollectionService.setCollection(null)

            showSlider()
        };

        $scope.editCollection = function (c) {
            VintCollectionService.setCollection(c)

            showSlider()
        }

        $scope.deleteCollection = function (c) {
            bootbox.confirm("Are you sure you want to delete the collection? This action cannot be undone.", function (r) {
                if (r) {
                    VintCollectionService.deleteCollection(c.id)
                }
            })
        }

        showSlider = function () {
            $scope.slideovers.collection = true;
        }
    }])

nsr.controller('AdminVintCollectionEditController', [
    '$scope', 'VintCollectionService', 'Admin',
    function ($scope, VintCollectionService, Admin) {

        $scope.$watch(function () {
            return VintCollectionService.collectionId
        }, function (n, o) {
            if (n != null && o != n) {
                $scope.load(n);
            }

            if (n === null) { // new Account
                clearCollection();
            }
        })

        function clearCollection() {
            $scope.edit = false;
            $scope.rules = {};
            $scope.collection = {};
        }

        clearCollection();

        $scope.load = function (collectionId) {
            $scope.edit = true;

            var result = Admin.get('vint-collections/' + collectionId);
            result.success(function (response) {
                $scope.collection = response.data;
            });
        };

        $scope.save = function () {
            if ($scope.edit) {
                VintCollectionService.edit($scope.collection).success(function () {
                    $scope.$parent.slideovers.collection = false;
                });
            } else {
                VintCollectionService.create($scope.collection).success(function (response) {
                    $scope.$parent.slideovers.collection = false;
                });
            }
        };

    }])


nsr.controller('AdminVintAccountController', [
    '$scope', '$http', '$timeout', 'Admin', '$auth', '$state', 'UserService', 'VintAccountService', 'TransitionService', 'VintCollectionService',
    function ($scope, $http, $timeout, Admin, $auth, $state, UserService, VintAccountService, TransitionService, VintCollectionService) {
        var settings = {};

        $scope.slideoverWidth = '500px';

        $scope.search = {
            description: ''
        };

        $scope.addAccount = function () {
            if (window.innerWidth < 500) {
                $scope.slideoverWidth = window.innerWidth + 'px';
            } else {
                $scope.slideoverWidth = 500 + 'px';
            }

            VintAccountService.account = {vendor_id: 13};

            $scope.slideovers.account = true;
        };

        $scope.buyShares = function (account) {
            if (window.innerWidth < 500) {
                $scope.slideoverWidth = window.innerWidth + 'px';
            } else {
                $scope.slideoverWidth = 500 + 'px';
            }

            VintAccountService.account = account;
            $scope.slideovers.buyDialog = true;
        };

        $scope.updateBalance = function (account) {
            TransitionService.showToastUntilCompleted(Admin.post('vint-update-balance/' + account), "Updating Balance...").then(function () {
                VintCollectionService.doRefreshTrigger = true
            });
        }

        $scope.loginAs = function (userId) {
            bootbox.confirm("This will end your current session and login you as the following investor, proceed?", function (r) {
                if (r) {
                    Admin.get('login-as/' + userId).then(function (response) {
                        $auth.setToken(response.data.auth_token);
                        TransitionService.showToastUntilCompleted(UserService.initUser(), "Switching user...").then(function () {
                            $state.go('dashboard', {}, {reload: true});
                        });
                    });
                }
            })
        };

        $scope.showData = function (account) {
            if (account.details) {
                account.details = !account.details;
                account.detailsData = null;
            } else {
                TransitionService.showToastUntilCompleted(Admin.post('vint-get-data/' + account.account_id), "Loading...").then(function (response) {
                    account.details = !account.details;
                    account.detailsData = response.data;
                })
            }
        }

        $scope.clearAllData = function (account) {
            bootbox.confirm("Transaction data, portfolio data, transfers and balances will be deleted. This action cannot be undone. Are you sure you want to delete all account data?", function (r) {
                if (r) {
                    TransitionService.showToastUntilCompleted(Admin.post('vint-clear-all-data/' + account.account_id), "Deleting account data...").then(function () {
                        VintCollectionService.doRefreshTrigger = true
                    })
                }
            })
        }

        $scope.deleteAccount = function (account) {
            bootbox.confirm("Are you sure you want to delete the account and all data associated with it? This action cannot be undone.", function (r) {
                if (r) {
                    TransitionService.showToastUntilCompleted(Admin.post('vint-delete-account/' + account.account_id), "Deleting account with all data...").then(function () {
                        VintCollectionService.doRefreshTrigger = true
                    })
                }
            })
        }
    }]);

nsr.controller('AdminVintAddAccountController', ['$rootScope', '$scope', '$http', '$timeout', 'Admin', '$auth', '$state', '$stateParams', '$uibModal', 'VintAccountService', 'VintCollectionService',
    function ($rootScope, $scope, $http, $timeout, Admin, $auth, $state, $stateParams, $uibModal, VintAccountService, VintCollectionService) {
        $scope.vendorList = $rootScope.vendors.list().filter(v => v.vendor_id === 13);

        $scope.$watch(function () {
            return VintAccountService.account
        }, function (n) {
            $scope.account = n
        })

        $scope.changeUser = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: '_change_user.html',
                controller: 'ChangeUserController',
                size: 'lg',
            });

            modalInstance.result.then(function (user_id) {
                $scope.account.user_id = user_id;
            }, function () {

            });
        };

        $scope.save = function () {
            VintAccountService.create($scope.account).success(function () {
                $scope.$parent.slideovers.account = false;
                VintCollectionService.doRefreshTrigger = true
            });
        };
    }]);

nsr.controller('ChangeUserController', ['$scope', '$controller', '$uibModalInstance', 'ErrorHandler', function ($scope, $controller, $uibModalInstance, ErrorHandler) {
    angular.extend(this, $controller('AdminUserController', {$scope: $scope}));

    $scope.ok = function (user_id) {
        $uibModalInstance.close(user_id);
    };

    $scope.cancel = function () {
        ErrorHandler.clearErrors();
        $uibModalInstance.dismiss('cancel');
    };
}]);

nsr.controller('ChangeCollectionController', [
    '$scope', '$controller', '$uibModalInstance', 'ErrorHandler', 'Admin',
    function ($scope, $controller, $uibModalInstance, ErrorHandler, Admin) {

        $scope.page = 1;
        $scope.search = {};

        $scope.reset = function () {
            $scope.search = {};
            $scope.page = 1;
            $scope.doSearch();
        };


        $scope.doSearch = function () {
            Admin.get('vint-collections?page=' + $scope.page + '&' + $.param($scope.search)).then(function (response) {
                $scope.collections = response.data;
            });
        };
        $scope.doSearch();

        $scope.ok = function (collection) {
            $uibModalInstance.close(collection);
        };

        $scope.cancel = function () {
            ErrorHandler.clearErrors();
            $uibModalInstance.dismiss('cancel');
        };
    }]);

nsr.controller('AdminVintBueSharesController', [
    '$scope', '$uibModal', 'VintAccountService', 'VintCollectionService',
    function ($scope, $uibModal, VintAccountService, VintCollectionService) {
        $scope.model = {
            collection: null,
            share_count: 0,
            total_amount: 0
        }

        const calc_amount = function () {
            if ($scope.model.collection) {
                $scope.model.total_amount = $scope.model.collection.share_price * $scope.model.share_count
            }
        }

        $scope.$watch(function () {
            return $scope.model.collection
        }, calc_amount)

        $scope.$watch(function () {
            return $scope.model.share_count
        }, calc_amount)

        $scope.changeCollection = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: '_change_collection.html',
                controller: 'ChangeCollectionController',
                size: 'lg',
            });

            modalInstance.result.then(function (collection) {
                $scope.model.collection = collection;
            }, function () {

            });
        };

        $scope.save = function () {
            VintAccountService.buy(VintAccountService.account, $scope.model).success(function () {
                $scope.$parent.slideovers.buyDialog = false;
                VintCollectionService.doRefreshTrigger = true
            });
        };
    }]);